/**
 * Recently viewed component
 * 
 * @module product-recently-viewed
 * @version 1.0.0
 * @extends HTMLElement
 */

customElements.component = 'product-recently-viewed';

if(!customElements.get(customElements.component)) {

    class recentlyViewed extends HTMLElement {

        /**
         * Recently viewed web component
         * 
         * @constructor
         */
        constructor() {

            super();

            this.currentProductHandle = this.dataset.rvProductHandle || "";

            if(this.currentProductHandle !== ""){
                this.setRecentlyViewedProduct();
            }

            this.render();

            this.initSlider();

            this.displayComponent();
            
        }

        /**
        * Render component in the DOM
        * 
        * @returns {undefined}
        */
        render() {

            let productGridhtml = "";
            const local = JSON.parse(localStorage.getItem(`${window.theme.environment}RecentlyViewedProduct`));
            this.localData = local ? local : [];

            this.localData.slice(0, 7).forEach((productHandle) => {

                if(productHandle !== this.currentProductHandle){
                    productGridhtml = productGridhtml + `<div class="swiper-slide"><product-card data-handle="${productHandle}"></product-card></div>`;
                }
            });

            this.querySelector('[recently-viewed-swiper-wrapper]'). innerHTML = productGridhtml;
        }

        /**
         * Set Recently Viewed Product
         * 
         * @returns {undefined}
         */
        setRecentlyViewedProduct() {

            let productList = [];

            let oldProductData = [];

            let localData = localStorage.getItem(`${window.theme.environment}RecentlyViewedProduct`);
            
            if(localData === null) {
                productList.push(this.currentProductHandle);
            }
            else {

                oldProductData = JSON.parse(localData);

                if(oldProductData.includes(this.currentProductHandle)){
                    oldProductData = oldProductData.filter( (returnableObjects) => {
                        return returnableObjects !== this.currentProductHandle;
                    });
                }

                productList.push(this.currentProductHandle, ...oldProductData);
            }

            let productDataString = JSON.stringify(productList);
            localStorage.setItem(`${window.theme.environment}RecentlyViewedProduct`, productDataString);
        }


        /**
         * Init slider.
         * 
         * @returns {undefined}
        */
        initSlider() {

            this.swiper = this.querySelector('[data-swiper]');

            let slidesPerViewMobile = (this.dataset.viewMobile) ? this.dataset.viewMobile : 1.1,
                slidesPerViewMobileExtra = (this.dataset.viewMobileExtra) ? this.dataset.viewMobileExtra : 2.1,
                slidesPerViewTablet = (this.dataset.viewTablet) ? this.dataset.viewTablet : 3.1,
                slidesPerViewTabletExtra = (this.dataset.viewTabletExtra) ? this.dataset.viewTabletExtra : 3,
                slidesPerViewDesktop = (this.dataset.viewDesktop) ? this.dataset.viewDesktop : 4;

            let defaultOptions = {
                slidesPerView: slidesPerViewMobile,
                watchSlidesVisibility: true,
                watchSlidesProgress: true,
                spaceBetween: 10,
                pagination: {
                    el: '.swiper-pagination',
                    dynamicBullets: true
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                },
                scrollbar: {
                    el: '.swiper-scrollbar'
                },
                breakpoints: {
                    600: {
                      slidesPerView: slidesPerViewMobileExtra
                    },
                    750: {
                      slidesPerView: slidesPerViewTablet,
                      spaceBetween: 10
                    },
                    900: {
                      slidesPerView: slidesPerViewTabletExtra,
                      spaceBetween: 20
                    },
                    1200: {
                        slidesPerView: slidesPerViewDesktop,
                        spaceBetween: 20
                    },
                    1500: {
                        slidesPerView: slidesPerViewDesktop,
                        spaceBetween: 20
                    }
                },
                on: {
                    init: () => { },
                    slideChange: index => { }
                }
            };

            let options = (this.dataset.options) ? JSON.parse(this.dataset.options) : {};

            this.options = {...defaultOptions, ...options};

            this.slider = new Swiper(this.swiper, this.options);
        }

        /**
         * Display Component validation.
         * 
         * @returns {undefined}
        */
        displayComponent() {
            
            if(this.localData.length > 0){

                if((this.localData.length == 1)&&(this.localData[0] == this.currentProductHandle)){
                    return;
                }

                this.parentElement.parentElement.classList.toggle("appear");
            }
        }
    }

    customElements.define(customElements.component, recentlyViewed);
}
  